import React from "react";
import { cn } from "../../utils/twMerge";

const BackDrop = (props) => {
  const { transHead, closeHandler, className } = props;
  return (
    <div
      className={cn(
        "fixed inset-0  z-[12] bg-blue-950 opacity-50",
        transHead && "top-[80px]",
        className,
      )}
      onClick={closeHandler}
    />
  );
};

export default BackDrop;
